"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledFormFeedback = exports.AudioInputChooser = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _propTypes = require("prop-types");
var _reactstrap = require("reactstrap");
var _chime = require("@studio/chime");
var _constants = require("@studio/constants");
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var StyledSelect = _styledComponents["default"].select(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  color: #6e7582;\n  border-style: solid;\n  border-width: 1px;\n  border-color: ", ";\n  padding: 8px 12px;\n  border-radius: 4px;\n  margin: 10px 0 0 0;\n  text-overflow: ellipsis;\n  width: 100%;\n\n  @media screen and (max-width: 768px) {\n    width: 100%;\n  }\n"])), function (_ref) {
  var hasError = _ref.hasError;
  return hasError ? '#DE2F1B' : '#DFE3EC';
});
var StyledFormFeedback = exports.StyledFormFeedback = (0, _styledComponents["default"])(_reactstrap.FormFeedback)(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n  color: #DE2F1B;\n  display: block;\n  margin-bottom: 10px;\n"])));
var StyledFormWrapper = _styledComponents["default"].div(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["\n  width: 100%;\n  display: block;\n"])));
var StyledOutputLevel = _styledComponents["default"].div(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2["default"])(["\n  height: 10px;\n  height: 16px;\n"])));
var StyledOutputChooser = _styledComponents["default"].div(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  align-items: center;\n  width: 100%;\n  @media screen and (max-width: 768px) {\n    width: 100%;\n  }\n"])));
var OutputIndicator = _styledComponents["default"].span(_templateObject6 || (_templateObject6 = (0, _taggedTemplateLiteral2["default"])(["\n  display: inline-block;\n  background: ", ";\n  border-radius: 2px;\n  width: 24px;\n  height: 16px;\n  margin: 0 1px;\n"])), function (_ref2) {
  var isActive = _ref2.isActive,
    color = _ref2.color;
  return isActive ? color : '#DFE3EC';
});
var OutputLevel = function OutputLevel(_ref3) {
  var volume = _ref3.volume;
  var filled = Math.round(volume / 10);
  var length = 10;
  var boxes = Array.from({
    length: length
  });
  var boxColor = filled < 5 ? '#DE2F1B' : '#28865e';
  return /*#__PURE__*/_react["default"].createElement(StyledOutputLevel, null, boxes.map(function (box, index) {
    return /*#__PURE__*/_react["default"].createElement(OutputIndicator, {
      key: index + boxColor,
      isActive: index < filled,
      color: boxColor
    });
  }));
};
var AudioInputChooser = exports.AudioInputChooser = function AudioInputChooser(_ref4) {
  var meetingSession = _ref4.meetingSession,
    onAudioInputChanged = _ref4.onAudioInputChanged,
    isMobile = _ref4.isMobile,
    showOutputLevel = _ref4.showOutputLevel,
    selectedAudioInputId = _ref4.selectedAudioInputId,
    id = _ref4.id;
  var _useState = (0, _react.useState)([]),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    devices = _useState2[0],
    setDevices = _useState2[1];
  var _useState3 = (0, _react.useState)(0),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    outputVolume = _useState4[0],
    setOutputVolume = _useState4[1];
  (0, _chime.useAudioVideoDevice)({
    meetingSession: meetingSession,
    setDevices: setDevices,
    onDeviceChanged: onAudioInputChanged,
    selectedDeviceId: selectedAudioInputId,
    deviceType: _constants.AUDIO_INPUT
  });
  var noDevices = devices === undefined || devices.length < 1;
  return /*#__PURE__*/_react["default"].createElement(StyledOutputChooser, null, /*#__PURE__*/_react["default"].createElement(StyledFormWrapper, null, /*#__PURE__*/_react["default"].createElement(StyledSelect, {
    id: id,
    onChange: function onChange(event) {
      return onAudioInputChanged(event.target.value);
    },
    hasError: noDevices
  }, devices.map(function (device) {
    return /*#__PURE__*/_react["default"].createElement("option", {
      key: device.deviceId,
      value: device.deviceId,
      selected: device.deviceId === selectedAudioInputId
    }, device.label);
  })), noDevices && /*#__PURE__*/_react["default"].createElement(StyledFormFeedback, {
    "data-testid": "form-feedback"
  }, "Select a microphone")), showOutputLevel ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, !isMobile && /*#__PURE__*/_react["default"].createElement(OutputLevel, {
    volume: outputVolume
  })) : '');
};
AudioInputChooser.propTypes = {
  meetingSession: _propTypes.object.isRequired,
  onAudioInputChanged: _propTypes.func.isRequired,
  selectedAudioInputId: _propTypes.string,
  id: _propTypes.string
};